import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M31.667 35V8.333A3.333 3.333 0 0 0 28.333 5H11.667a3.333 3.333 0 0 0-3.334 3.333V35m23.334 0H35m-3.333 0h-8.334m-15 0H5m3.333 0h8.334M15 11.667h1.667M15 18.333h1.667m6.666-6.666H25m-1.667 6.666H25M16.667 35v-8.333c0-.92.746-1.667 1.666-1.667h3.334c.92 0 1.666.746 1.666 1.667V35m-6.666 0h6.666"
    }, null, -1)
  ]))]))
}
export default { render: render }